import { useEffect, useContext} from "react"
import { Link } from "react-router-dom";

export const HomePage = () => {
    

    return (
        <div className="flex flex-col justify-center px-6 py-12 lg:px-8 bg-white dark:bg-gray-900 dark:text-white ">
            <div className="sm:mx-auto sm:w-full sm:max-w-sm">
                <h2 className="mt-10 text-center text-2xl font-bold leading-9 tracking-tight text-gray-900 dark:text-white">
                    Gestión de Proyectos- Dirección Provincial de Intervenciones Complementarias
                </h2>               
            </div>            
        </div>
    )
}

//bg-custom-cyan border-solid border-8 border-gray-300